import type { NavigationContent, NavigationItemContent, DRXNavigationContent } from "../types";

const PHONE_NUMBER = "0208 123 0508";

const NavContent: NavigationContent = {
  items: [
    {
      label: "Weight Loss",
      items: [
        {
          label: "All Weight Loss",
          href: "/clinics/weight-loss",
        },
      ],
    },
    {
      label: "Sexual Performance",
      items: [
        {
          label: "Erectile Dysfunction",
          href: "/clinics/erectile-dysfunction",
        },
        {
          label: "Premature Ejaculation",
          href: "/clinics/premature-ejaculation",
        },
      ],
    },
    {
      label: "Sexual Health",
      items: [
        {
          label: "Bacterial Vaginosis",
          href: "/clinics/bacterial-vaginosis",
        },
        {
          label: "Cystitis",
          href: "/clinics/cystitis",
        },
        {
          label: "Emergency Contraception",
          href: "/clinics/emergency-contraception",
        },
        {
          label: "Period Delay",
          href: "/clinics/period-delay",
        },
        {
          label: "Thrush",
          href: "/clinics/thrush",
        },
      ],
    },
    {
      label: "STIs",
      items: [
        {
          label: "Chlamydia",
          href: "/clinics/sexual-health/chlamydia",
        },
        {
          label: "Genital Herpes",
          href: "/clinics/sexual-health/genital-herpes",
        },
        {
          label: "Genital Warts",
          href: "/clinics/sexual-health/genital-warts",
        },
      ],
    },
    {
      label: "Pain Relief",
      items: [
        {
          label: "Arthritis",
          href: "/clinics/arthritis",
        },
        {
          label: "Migraine",
          href: "/clinics/migraine",
        },
        {
          label: "Numbing Cream",
          href: "/clinics/numbing-cream/emla",
        },
      ],
    },
    {
      label: "Hair, Skin and Nails",
      items: [
        {
          label: "Acne",
          href: "/clinics/acne",
        },
        {
          label: "Cold Sores",
          href: "/clinics/cold-sore",
        },
        {
          label: "Eczema",
          href: "/clinics/eczema",
        },
        {
          label: "Hair Loss",
          href: "/clinics/hair-loss",
        },
        {
          label: "Nail Infection",
          href: "/clinics/fungal-nail-infection/curanail-loceryl",
        },
        {
          label: "Rosacea",
          href: "/clinics/rosacea",
        },
        {
          label: "Vitamins",
          href: "/clinics/vitamins/perfectil",
        },
      ],
    },
    {
      label: "Asthma and Allergies",
      items: [
        {
          label: "Asthma",
          href: "/clinics/asthma",
        },
        {
          label: "Hay Fever",
          href: "/clinics/hay-fever",
        },
      ],
    },
    {
      label: "Digestive Health",
      items: [
        {
          label: "Acid Reflux",
          href: "/clinics/acid-reflux",
        },
        {
          label: "IBS",
          href: "/clinics/irritable-bowel-syndrome",
        },
        {
          label: "Threadworm",
          href: "/clinics/threadworm/ovex",
        },
      ],
    },
    {
      label: "Seasonal Viruses",
      items: [
        {
          label: "COVID-19 Tests",
          href: "/clinics/covid-19",
        },
        {
          label: "Flu",
          href: "/clinics/flu",
        },
      ],
    },
    {
      label: "Travel Health",
      items: [
        {
          label: "Anti-Malaria",
          href: "/clinics/malaria",
        },
        {
          label: "Jet Lag",
          href: "/clinics/jetlag",
        },
        {
          label: "Sleep",
          href: "/clinics/sleep/nytol",
        },
      ],
    },
  ],
};

const SecondaryLinks: Array<NavigationItemContent> = [
  {
    label: "How it works",
    href: "/how-it-works",
  },
  {
    label: "Delivery",
    href: "/delivery",
  },
  {
    label: "FAQs",
    href: "/faq",
  },
  {
    label: "Reviews",
    href: "/reviews",
  },
  {
    label: "About",
    href: "/about-us",
  },
  {
    label: "Contact",
    href: "/contact",
  },
];

const callLinkContent = {
  label: "Call customer care",
  number: PHONE_NUMBER,
  href: `tel:${PHONE_NUMBER}`,
};

export const DRXNavContent: DRXNavigationContent = {
  primaryExpandedContent: NavContent,
  secondaryNavigationLinks: SecondaryLinks,
  callLinkContent,
};
